import { Pipe, PipeTransform } from "@angular/core";
import { getUserRequestDTOS } from "../../../functions/booking-utils.functions";
import { NsEmpWebExpData } from "../../../models/emp-web-exp.model";

@Pipe({
  name: "iconOverflowCheck"
})
export class IconOverFlowPipe implements PipeTransform {
  transform(booking: NsEmpWebExpData.IBookingDetailDTOS, meal: boolean, parking: boolean): boolean {
    const cabBooked = getUserRequestDTOS(booking);
    const deskBooked = booking?.tokenId;
    return deskBooked && ((cabBooked && meal) || (cabBooked && parking) || (meal && parking));
  }
}
